import { motion } from 'framer-motion'
import { BalloonLayer } from '../ui/BalloonSVG'

const itemVariants = {
  hidden: { opacity: 0, y: 24 },
  show:   { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
}

export default function AboutHero() {
  return (
    <section
      className="relative pt-32 pb-20 overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #FF6BB5 0%, #7C3AFF 100%)' }}
    >
      <div className="absolute bottom-0 left-1/3 w-64 h-64 bg-white/10 rounded-full blur-3xl pointer-events-none" />
      <BalloonLayer opacity={0.28} />

      <div className="container-custom relative z-10 text-center">
        <motion.p
          variants={itemVariants}
          initial="hidden"
          animate="show"
          className="inline-flex items-center gap-2 mb-5 px-5 py-2 rounded-full bg-white/20 border border-white/30 text-white text-sm font-body font-bold tracking-widest uppercase backdrop-blur-sm"
        >
          🌟 Our Story
        </motion.p>

        <motion.h1
          variants={itemVariants}
          initial="hidden"
          animate="show"
          transition={{ delay: 0.1 }}
          className="font-display text-5xl md:text-6xl text-white mb-6"
        >
          About Farafeero World
        </motion.h1>

        <motion.p
          variants={itemVariants}
          initial="hidden"
          animate="show"
          transition={{ delay: 0.2 }}
          className="font-body text-white/80 text-lg max-w-xl mx-auto"
        >
          We don't just plan parties... we create memories
        </motion.p>
      </div>
    </section>
  )
}
